"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetLatestAgreementTermResponseToJSON = exports.GetLatestAgreementTermResponseFromJSONTyped = exports.GetLatestAgreementTermResponseFromJSON = void 0;
var _1 = require("./");
function GetLatestAgreementTermResponseFromJSON(json) {
    return GetLatestAgreementTermResponseFromJSONTyped(json, false);
}
exports.GetLatestAgreementTermResponseFromJSON = GetLatestAgreementTermResponseFromJSON;
function GetLatestAgreementTermResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'agreementTerm': (0, _1.AgreementTermFromJSON)(json['agreementTerm']),
    };
}
exports.GetLatestAgreementTermResponseFromJSONTyped = GetLatestAgreementTermResponseFromJSONTyped;
function GetLatestAgreementTermResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'agreementTerm': (0, _1.AgreementTermToJSON)(value.agreementTerm),
    };
}
exports.GetLatestAgreementTermResponseToJSON = GetLatestAgreementTermResponseToJSON;
